var map = {
  "./example.svg": "5747",
  "./icon--burger.svg": "6945",
  "./icon--close.svg": "5630",
  "./icon--exit.svg": "1965",
  "./icon--facebook.svg": "7990",
  "./icon--info.svg": "642",
  "./icon--instagram.svg": "9058",
  "./icon--linkedin.svg": "4852",
  "./icon--logo-mobile.svg": "9586",
  "./icon--logo.svg": "7379",
  "./icon--open.svg": "418",
  "./icon--pagination-1.svg": "4616",
  "./icon--pagination-2.svg": "155",
  "./icon--pagination-3.svg": "1338",
  "./icon--pagination-4.svg": "437",
  "./icon--play.svg": "9896",
  "./icon--tick.svg": "4065",
  "./icon--twitter.svg": "6675",
  "./icon--waffle-trans.svg": "6870",
  "./icon--youtube.svg": "9193"
};


function __rspack_context(req) {
  var id = __rspack_context_resolve(req);
  return __webpack_require__(id);
}
function __rspack_context_resolve(req) {
  if(!__webpack_require__.o(map, req)) {
    var e = new Error("Cannot find module '" + req + "'");
    e.code = 'MODULE_NOT_FOUND';
    throw e;
  }
  return map[req];
}
__rspack_context.keys = function webpackContextKeys() {
  return Object.keys(map);
};
__rspack_context.resolve = __rspack_context_resolve;
module.exports = __rspack_context;
__rspack_context.id = 8995;
